import {
    isMultiEnvironmentModeActive,
    getSelectedMultiEnvironmentIds,
} from 'utils/multiEnvironment';
import { shouldSkipListGlobalMultiEnvironmentFilter } from 'utils/listGlobalMultiEnvironmentFilter';

const selectFiltersKey = (ownProps) => ownProps.filterKey || ownProps.entity?.entity || '';
const selectEntityName = (ownProps) => ownProps.entity?.entity || '';

const selectEntityFilters = (state, ownProps) => {
    const entityKey = selectFiltersKey(ownProps);
    return state.entityFilters[entityKey] || {};
};

const selectPrincipalFilter = (state, ownProps) => {
    const entityName = selectEntityName(ownProps);
    return state.config.userData?.principalFilter?.[entityName] || null;
};

const selectStandardFieldsSchemaMap = (state, ownProps) => {
    const extraFieldName = ownProps?.entity?.extraFieldName;
    return state.config?.standardFieldsSchemaMap?.[extraFieldName] || null;
};

const selectCache = (state, ownProps) => {
    if (ownProps.avoidStorage) {
        return ownProps?.customCache || null;
    }
    const entityKey = selectFiltersKey(ownProps);
    return state.config.components?.[`${entityKey}_filters`] || null;
};

const selectMultiEnvironmentData = (state, ownProps) => {
    const filtersKey = selectFiltersKey(ownProps);
    const environmentFilterField = ownProps.entity?.environmentFilterField;
    const isMultiEnvActive = isMultiEnvironmentModeActive(state);
    const skipManualEnvironmentFilter = shouldSkipListGlobalMultiEnvironmentFilter(
        state,
        filtersKey || undefined,
    );
    const selectedEnvironmentIds = getSelectedMultiEnvironmentIds(state);
    const environments = state?.serverList?.tblSucursales?.data || [];
    const selectedEnvironments = environments.filter((env) =>
        selectedEnvironmentIds.includes(env.value),
    );

    return {
        environmentFilterField,
        isMultiEnvironmentActive:
            !skipManualEnvironmentFilter && isMultiEnvActive && !!environmentFilterField,
        selectedEnvironmentIds,
        selectedEnvironments,
    };
};

const mapStateToProps = (state, ownProps) => {
    const entityFilters = selectEntityFilters(state, ownProps);
    const avoidStorage = ownProps.avoidStorage;

    return {
        filters: avoidStorage ? ownProps.filters : entityFilters.filters || null,
        serverList: state.serverList,
        principalFilter: selectPrincipalFilter(state, ownProps),
        cache: selectCache(state, ownProps),
        views: state.config.views,
        viewsPublicManagement: state.config.permission?.viewsPublicManagement,
        viewsPrivateManagement: state.config.permission?.viewsPrivateManagement,
        standardFieldsSchemaMap: selectStandardFieldsSchemaMap(state, ownProps),
        filterDragging: entityFilters.filterDragging,
        operators: avoidStorage ? ownProps.operators : entityFilters.operators || {},
        license: state.config?.subscriptionModeCode || '',
        enableSalesOrdersTypes: state.config?.userData?.enableSalesOrdersTypes,
        crossFilters: avoidStorage ? ownProps.crossFilters : entityFilters.crossFilters || {},
        crossOperators: avoidStorage ? ownProps.crossOperators : entityFilters.crossOperators || {},
        multiEnvironmentData: selectMultiEnvironmentData(state, ownProps),
    };
};

export default mapStateToProps;
